import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';
import mockSale from 'mocks/vessel/sales.json';

const vesselSales = (state = {
    items: [],
    user: {
        email: '',
        company: '',
        name: '',
        surname: '',
        phones: [{
            code: '',
            phone: '',
        }],
    },
    isLoaded: false,
}, action) => {
    switch (action.type) {
    case actionTypes.REMOVE_ALL_VESSEL_SALES: {
        return {
            ...state,
            items: [],
        };
    }
        
    case actionTypes.UPDATE_VESSEL_SALE_USER: {
        const newState = _.cloneDeep(state);
        newState.user = { ...action.user };
        return newState;
    }
        
    case actionTypes.CREATE_VESSEL_SALES: {
        return {
            ...state,
            items: action.items,
        };
    }
        
    case actionTypes.GET_VESSEL_SALES.REQUEST:
        return state;

    case actionTypes.GET_VESSEL_SALES.SUCCESS:
        const data = action.data.data.map(item => ({
            ...item,
            isUpdate: false,
        }));
    
        return {
            ...state,
            ...action.data,
            isLoaded: true,
            data,
        };

    case actionTypes.GET_VESSEL_SALES.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };
        
    case actionTypes.UPDATE_VESSEL_SALE: {
        const newState = _.cloneDeep(state);
        newState.items[action.numberSale] = action.newVesselSale;
        return newState;
    }
        
    case actionTypes.REMOVE_LAST_VESSEL_SALE: {
        const newState = _.cloneDeep(state);
        newState.items.splice(-1, 1);
        return newState;
    }
        
    case actionTypes.ADD_VESSEL_SALE: {
        const newState = _.cloneDeep(state);
        const cloneMockSale = _.cloneDeep(mockSale);

        newState.items.push({ ...cloneMockSale });
        return newState;
    }

    case actionTypes.POST_VESSEL_SALE.REQUEST: {
        return {
            ...state,
            data: [],
        };
    }
        
    case actionTypes.POST_VESSEL_SALE.FAILURE: {
        return { ...state };
    }
        
    case actionTypes.POST_VESSEL_SALE.SUCCESS: {
        const data = _.cloneDeep(state.data);
        data.push(action.vesselRequest);
        return { ...state, data };
    }

    case actionTypes.DELETE_VESSEL_SALE.REQUEST: {
        return {
            ...state,
        };
    }
    case actionTypes.DELETE_VESSEL_SALE.SUCCESS: {
        const data = state.data.map((item) => {
            if (item._id === action.saleId) {
                return {
                    ...item,
                    deleteBy: { email: action.email },
                    deleteAt: new Date(),
                };
            }
    
            return item;
        });
    
        return {
            ...state,
            data,
        };
    }
    case actionTypes.DELETE_VESSEL_SALE.FAILURE: {
        const data = state.data.map((item) => {
            if (item._id === action.saleId) {
                return {
                    ...item,
                    errors: action.errors,
                };
            }
    
            return item;
        });
    
        return {
            ...state,
            data,
        };
    }

    default:
        return state;
    }
};

export default vesselSales;



// WEBPACK FOOTER //
// ./app/reducers/vessels/sales.js